import { css } from '@emotion/core'
import { Heading, Text, VFlow } from 'bold-ui'
import { ReactNode } from 'react'

interface HistoricoMChatResultadoProps {
  title: string
  label: string
  encaminhamento: ReactNode
  titleColor: string
}

export function HistoricoMChatResultado(props: Readonly<HistoricoMChatResultadoProps>) {
  const { title, label, encaminhamento, titleColor } = props

  return (
    <VFlow vSpacing={0.5}>
      <Heading level={4}>Resultado:</Heading>
      <Heading level={3}>
        <Text style={styles.title(titleColor)}>{title}</Text>
        <Text style={styles.label}> | {label}</Text>
      </Heading>
      <VFlow vSpacing={0}>
        <Heading level={5}>Encaminhamento</Heading>
        <Text style={styles.encaminhamento}>{encaminhamento}</Text>
      </VFlow>
    </VFlow>
  )
}

const styles = {
  title: (color: string) => css`
    color: ${color};
    font-size: inherit;
  `,
  label: css`
    font-size: inherit;
    font-weight: normal;
  `,
  encaminhamento: css`
    & span,
    & strong {
      font-weight: normal;
    }
  `,
}
